import { useAtom } from 'jotai'

import { downloadGeneralContractorOrderXlsmStore } from 'src/stores'

export const useDownloadGeneralContractorOrderXlsmStore = () => {
  const [
    downloadGeneralContractorOrderXlsmStoreValue,
    setDownloadGeneralContractorOrderXlsmStoreValue,
  ] = useAtom(downloadGeneralContractorOrderXlsmStore.state)

  return {
    downloadGeneralContractorOrderXlsmStoreValue,
    setDownloadGeneralContractorOrderXlsmStoreValue,
  }
}
